import type { CityConfig } from "../city-template/types";

export const urbandaleConfig: CityConfig = {
  city: "Urbandale",
  state: "Iowa",
  stateAbbr: "IA",
  slug: "urbandale",
  route: "/cities/urbandale",
  title: "Emergency Passport Urbandale, IA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Urbandale, IA — as fast as 24 hours. Serving Polk County and the Des Moines metro. A+ BBB rated registered State Dept. courier serving insurance, finance, and tech corridor professionals. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Urbandale, IA",
  heroSubtitle: "Insurance executive with a last-minute London conference? Tech corridor developer heading to a product launch in Tokyo with no passport? Finance professional with an urgent client meeting in Zurich and expired documents? We help Urbandale and Des Moines metro residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Urbandale%20Iowa%20suburban%20Des%20Moines%20metro%20modern%20office%20parks%20corporate%20headquarters%20green%20neighborhoods%20Johnston%20Grimes%20corridor%20professional%20community%20golden%20hour%20warm%20sunlight%20aerial%20photography%20Midwest%20business%20hub&width=1800&height=700&seq=urbandale-hero-ia-2026&orientation=landscape",
  heroImageAlt: "Urbandale Iowa suburban Des Moines metro corporate office parks at golden hour",
  geoPosition: "41.6333;-93.7333",
  geoPlacename: "Urbandale, Iowa",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 335 miles east of Urbandale via I-80/I-88",
  },
  nearbyCitiesZips: [
    { name: "Urbandale", zips: "50322, 50323" },
    { name: "Johnston", zips: "50131" },
    { name: "Clive", zips: "50325" },
    { name: "Waukee", zips: "50263" },
    { name: "West Des Moines", zips: "50265, 50266" },
    { name: "Windsor Heights", zips: "50324" },
    { name: "Grimes", zips: "50111" },
    { name: "Des Moines", zips: "50301–50327" },
    { name: "Ankeny", zips: "50021, 50023" },
    { name: "Altoona", zips: "50009" },
    { name: "Norwalk", zips: "50211" },
    { name: "Indianola", zips: "50125" },
    { name: "Ames", zips: "50010–50014" },
    { name: "Marshalltown", zips: "50158" },
    { name: "Boone", zips: "50036" },
    { name: "Perry", zips: "50220" },
    { name: "Adel", zips: "50003" },
    { name: "Dallas Center", zips: "50063" },
    { name: "Polk City", zips: "50226" },
    { name: "Bondurant", zips: "50035" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Des Moines metro departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Des Moines Metro Coverage", desc: "Serving Urbandale, Johnston, Clive, Waukee, and Polk County" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Des Moines, IA", route: "/cities/des-moines" },
    { name: "Fast passport renewal in West Des Moines, IA", route: "/cities/west-des-moines" },
    { name: "Emergency passport help in Ankeny, IA", route: "/cities/ankeny" },
    { name: "Urgent passport services in Johnston, IA", route: "/cities/johnston-ia" },
    { name: "Same-day passport help in Ames, IA", route: "/cities/ames" },
    { name: "Passport courier services in Cedar Rapids, IA", route: "/cities/cedar-rapids" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Urbandale remotely via secure courier. We do not have a walk-in office in Urbandale — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Polk County and the entire Des Moines metro.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Polk County and the Des Moines metro region including Urbandale, Johnston, Clive, Waukee, and Grimes",
  serviceAreaIntro: "From the insurance and finance corporate campuses along the I-35/80 corridor to the upscale subdivisions of Urbandale, from the Corteva Pioneer campus in Johnston to the thriving commercial district along Hickman Road, from the family-friendly parks and trails of the western suburbs to the tech companies of the Des Moines metro — Fast Passport Center serves the entire Urbandale and western Polk County region. We regularly help travelers from Urbandale, Johnston, Clive, Waukee, and West Des Moines get their passports fast without the 5.5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all Urbandale neighborhoods and the surrounding Des Moines metro area including Johnston, Clive, Waukee, West Des Moines, Grimes, and Windsor Heights. If you are anywhere in western Polk County or the Des Moines metro, we have you covered.",
  howItWorksIntro: "Most Urbandale travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "Des Moines metro travelers often face a 5.5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Urbandale and western Polk County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Urbandale? Here are the most common ones we hear from Des Moines metro travelers.",
  statePageRoute: "/states/iowa",
  statePageName: "Iowa",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Iowa HHS Vital Records (Birth, Death)", url: "https://hhs.iowa.gov/vital-records", desc: "Official Iowa vital records office in Des Moines" },
    { icon: "ri-heart-pulse-line", label: "Polk County Recorder — Marriage Licenses", url: "https://www.polkcountyiowa.gov/recorder/", desc: "Polk County Recorder — marriage records" },
    { icon: "ri-scales-line", label: "Iowa Courts — Divorce Records", url: "https://www.iowacourts.gov/", desc: "Iowa Judicial Branch — divorce decree records" },
    { icon: "ri-global-line", label: "VitalChek — Order Online", url: "https://www.vitalchek.com/", desc: "Official partner for online vital record orders" },
  ],
  dmvWebsite: "https://iowadot.gov/mvd",
  dmvLabel: "Iowa DOT — Motor Vehicle Division",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Urbandale travelers with immediate departure needs — as fast as 24 hours for urgent international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Mark D.",
      location: "Urbandale, IA",
      rating: 5,
      text: "Insurance conference in Bermuda with 3 days notice. My passport had expired and I didn't realize. Fast Passport Center got it renewed in 2 days. I made my flight out of Des Moines. My entire department uses them now.",
      service: "Passport Renewal",
    },
    {
      name: "Priya S.",
      location: "Urbandale, IA",
      rating: 5,
      text: "Tech product launch in Singapore — 5 days notice. Fast Passport Center handled everything including my visa documentation timeline. Passport in 36 hours. From Urbandale to Singapore in under a week. Unreal.",
      service: "Emergency Passport",
    },
    {
      name: "The Harrisons",
      location: "Clive, IA",
      rating: 5,
      text: "Family trip to Italy over spring break. Our teenager needed a new passport and we had 10 days. Fast Passport Center came through in 4 days. We toured Rome and Florence without a single issue. Worth every penny.",
      service: "New Passport",
    },
  ],
  facilities: [
    {
      id: "urbandale-1",
      name: "Urbandale Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "3311 100th St",
      city: "Urbandale",
      state: "IA",
      zip: "50322",
      phone: "(515) 254-5000",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Central Urbandale",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Urbandale facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "urbandale-2",
      name: "Polk County Recorder's Office",
      type: "County Recorder Passport Acceptance",
      address: "111 Court Ave, Room 250",
      city: "Des Moines",
      state: "IA",
      zip: "50309",
      phone: "(515) 286-3161",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "10 miles southeast in downtown Des Moines",
      website: "https://www.polkcountyiowa.gov/recorder",
      websiteLabel: "Polk County Recorder",
      notes: "Accepts passport applications for Polk County. Extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "urbandale-3",
      name: "Johnston Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6400 Merle Hay Rd",
      city: "Johnston",
      state: "IA",
      zip: "50131",
      phone: "(515) 278-4111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles north in Johnston",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Johnston and northern Polk County. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "urbandale-4",
      name: "Clive Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1900 NW 114th St",
      city: "Clive",
      state: "IA",
      zip: "50325",
      phone: "(515) 223-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "3 miles west in Clive",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Clive and western Polk County. Full passport services.",
      icon: "ri-mail-line",
    },
    {
      id: "urbandale-5",
      name: "West Des Moines Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6635 Mills Civic Pkwy",
      city: "West Des Moines",
      state: "IA",
      zip: "50266",
      phone: "(515) 223-2111",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles south in West Des Moines",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves West Des Moines. Full passport services in the Jordan Creek area.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5.5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Courier Service", agency: "Not available — self-transport only", fpc: "Registered courier hand-delivers documents" },
    { feature: "Photo Services", agency: "Not available at agency — must bring own", fpc: "Photo review and guidance included" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Urbandale photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Polk County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Urbandale applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Polk County families at the county recorder.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Urbandale travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Urbandale." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Urbandale address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Urbandale before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Urbandale for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5.5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in Urbandale?", a: "Fast Passport Center offers fast passport renewal in Urbandale in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Urbandale?", a: "The nearest regional passport agency to Urbandale is the Chicago Passport Agency, approximately 335 miles east via I-80/I-88. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Urbandale without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Urbandale?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5.5 hours from Urbandale — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Polk County residents." },
    { q: "Do you serve the entire western Des Moines metro?", a: "Absolutely. Fast Passport Center serves the entire western Des Moines metro including Urbandale, Johnston, Clive, Waukee, Grimes, West Des Moines, and Windsor Heights. Our courier service works seamlessly from any address in Polk County." },
    { q: "Can I expedite a child passport in Urbandale?", a: "Yes. Fast Passport Center expedites child passports in Urbandale for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Polk County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Urbandale with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — Ankeny", address: "1002 SE National Dr, Ankeny, IA 50021", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — Urbandale", address: "8601 Douglas Ave, Urbandale, IA 50322", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — West Des Moines", address: "3400 SE 14th St, West Des Moines, IA 50265", hours: "Mon–Sun: 8AM–10PM" },
    { name: "FedEx Office — West Des Moines", address: "6305 Mills Civic Pkwy, West Des Moines, IA 50266", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
  ],
  dmvLocations: [
    {
      name: "Iowa DOT — Ankeny Driver's License",
      address: "6310 SE Convenience Blvd, Ankeny, IA 50021",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services for Polk County. Closest to Urbandale. Appointment recommended.",
      featured: true,
    },
    {
      name: "Iowa DOT — Des Moines Driver's License",
      address: "1103 SW 63rd St, Des Moines, IA 50312",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Polk County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Iowa DOT — Ames Driver's License",
      address: "2321 E 13th St, Ames, IA 50010",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Story County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DSM",
      name: "Des Moines International Airport",
      distance: "15 miles south of Urbandale",
      address: "5800 Fleur Dr, Des Moines, IA 50321",
      note: "Iowa's largest airport with direct flights nationwide. About 20 minutes from Urbandale via I-235.",
      flightUrl: "https://www.dsmairport.com/",
      flightLabel: "DSM Airport",
      featured: true,
    },
    {
      code: "CID",
      name: "Eastern Iowa Airport",
      distance: "130 miles east of Urbandale",
      address: "2121 Arthur Collins Pkwy SW, Cedar Rapids, IA 52404",
      note: "Regional airport with direct flights to major hubs. About 2 hours from Urbandale.",
      flightUrl: "https://www.eiairport.org/",
      flightLabel: "CID Airport",
      featured: false,
    },
    {
      code: "OMA",
      name: "Eppley Airfield — Omaha",
      distance: "135 miles west of Urbandale",
      address: "4501 Abbott Dr, Omaha, NE 68110",
      note: "Major regional airport with direct flights nationwide. About 2 hours from Urbandale via I-80.",
      flightUrl: "https://www.flyoma.com/",
      flightLabel: "OMA Airport",
      featured: false,
    },
  ],
};